export const getDashboardEnvironment = ():
  | "production"
  | "staging"
  | "testing"
  | "development" => {
  return import.meta.env.VITE_DASHBOARD_ENVIRONMENT || "production";
};

export const currLocalClient = "propertysense";

const getEnvironmentDomain = () => {
  const env = getDashboardEnvironment();
  switch (env) {
    case "testing":
      return "test.";
    case "staging":
      return "stg.";
    default:
      return "";
  }
};

export const getClientDomain = () => {
  const env = getDashboardEnvironment();
  if (env !== "development") {
    const host = window.location.hostname;
    return host.split(".")[0];
  } else {
    return currLocalClient;
  }
};

export const getNewClientUrl = (clientCode: string) => {
  const env = getDashboardEnvironment();
  const currProtocol = window.location.protocol;
  if (!clientCode) {
    return `${currProtocol}//${getClientDomain()}.${getEnvironmentDomain()}${
      import.meta.env.VITE_BASE_ORIGIN_URL
    }`;
  }
  if (env !== "development") {
    return `${currProtocol}//${clientCode}.${getEnvironmentDomain()}${
      import.meta.env.VITE_BASE_ORIGIN_URL
    }`;
  } else {
    return `${currProtocol}//localhost:8081`;
  }
};

const DTE_SUPERADMIN_ENABLED_CLIENTS = [
  "londonist",
  "nowstudents",
  "herestudents",
  "vivuskwallsop",
];

export const isDTEAllowed = (currentUserRole: string | undefined): boolean => {
  if (currentUserRole === "vf-admin") return true;
  if (
    currentUserRole === "superadmin" &&
    DTE_SUPERADMIN_ENABLED_CLIENTS.includes(getClientDomain())
  ) {
    return true;
  }
  return false;
};

export const redirectToNewClient = (
  clientCode: string,
  newTab: boolean = false
) => {
  const env = getDashboardEnvironment();
  if (env !== "development") {
    const baseOrigin = import.meta.env.VITE_BASE_ORIGIN_URL;
    const currProtocol = window.location.protocol;
    const currPath = window.location.pathname || "";
    const currSearch = window.location.search || "";
    const currHash = window.location.hash || "";
    const newUrl = `${currProtocol}//${clientCode}.${getEnvironmentDomain()}${baseOrigin}${currPath}${currSearch}${currHash}`;
    if (newTab) {
      window.open(newUrl, "_blank");
    } else {
      window.location.replace(newUrl);
    }
  } else if (env === "development") {
    window.location.reload();
  }
};
